import { forwardRef } from "react";

const W = 900;

function TeamBox({ names, chosen, score }) {
  return (
    <div
      style={{
        flex: 1,
        padding: "14px 18px",
        borderRadius: "14px",
        background: chosen ? "linear-gradient(135deg,#10B981,#047857)" : "#0d1526",
        border: chosen ? "2px solid #34d399" : "2px solid #1e293b",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
      }}
    >
      <span style={{ color: chosen ? "#04120b" : "#cbd5e1", fontWeight: 800, fontSize: "18px" }}>
        {names.join(" / ")}
      </span>
      <span style={{ color: chosen ? "#04120b" : "#94a3b8", fontWeight: 900, fontSize: "18px", fontFamily: "'JetBrains Mono', monospace" }}>
        {score}
      </span>
    </div>
  );
}

export const FantaExportCard = forwardRef(({ matchday, date, nickname, matches = [], picks = {}, appUrl }, ref) => {
  const prettyDate = date
    ? new Date(date).toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })
    : "";

  return (
    <div
      ref={ref}
      style={{
        position: "fixed", left: "-10000px", top: 0, width: `${W}px`,
        background: "#0B0F19", padding: "40px", boxSizing: "border-box",
        fontFamily: "'Plus Jakarta Sans', sans-serif",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "22px" }}>
        <div
          style={{
            width: "56px", height: "56px", borderRadius: "16px",
            background: "linear-gradient(135deg,#d946ef,#10B981)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontWeight: 900, fontSize: "28px",
            fontFamily: "'Barlow Condensed', sans-serif",
          }}
        >
          AP
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, textTransform: "uppercase", fontSize: "32px", color: "#fff", lineHeight: 1 }}>
            American Padel 2026
          </div>
          <div style={{ color: "#d946ef", fontSize: "14px", letterSpacing: "4px", marginTop: "4px" }}>
            FANTAPADEL · IL MIO PRONOSTICO
          </div>
        </div>
        {prettyDate && <div style={{ color: "#64748B", fontSize: "14px", textTransform: "capitalize" }}>{prettyDate}</div>}
      </div>

      <div style={{ display: "flex", alignItems: "baseline", gap: "12px", marginBottom: "22px" }}>
        <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 900, fontSize: "40px", color: "#fff", textTransform: "uppercase", lineHeight: 1 }}>
          {nickname}
        </span>
        <span style={{ color: "#94a3b8", fontSize: "18px" }}>· Giornata {matchday}</span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
        {matches.map((m) => {
          const p = picks[String(m.court)] || {};
          const sets = p.sets || [];
          const t1Score = sets.map((s) => s.g1).join(" ");
          const t2Score = sets.map((s) => s.g2).join(" ");
          return (
            <div key={m.court}>
              <div style={{ color: "#64748b", fontSize: "12px", letterSpacing: "2px", textTransform: "uppercase", marginBottom: "6px", fontFamily: "'JetBrains Mono', monospace" }}>
                Campo {m.court}
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <TeamBox names={m.team1} chosen={p.winner === "team1"} score={t1Score} />
                <span style={{ color: "#475569", fontWeight: 900, fontSize: "15px", fontFamily: "'JetBrains Mono', monospace" }}>VS</span>
                <TeamBox names={m.team2} chosen={p.winner === "team2"} score={t2Score} />
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: "26px", display: "flex", justifyContent: "space-between", alignItems: "center", color: "#94a3b8", fontSize: "15px" }}>
        <span style={{ fontWeight: 700 }}>🎾 Fai il tuo pronostico anche tu!</span>
        <span style={{ color: "#10B981", fontFamily: "'JetBrains Mono', monospace", fontSize: "13px" }}>{appUrl}</span>
      </div>
    </div>
  );
});

FantaExportCard.displayName = "FantaExportCard";
